import axios from 'axios'
const apiUsuario = 'core/php/api/perfil/'

const get = (url) => {
	return axios.get(apiUsuario + url)
}

const post = (url, data) => {
	return axios.post(apiUsuario + url, data)
}

export default {
	getUsuario: (idUsuario) => {
		return get('get-perfil.php')
	},
	setUsuario: (datos) => {
		const form = _.clone(datos)
		form.fecha_nacimiento = (form.fecha_nacimiento) ? Math.floor(datos.fecha_nacimiento.getTime() / 1000) : null
		return post('set-perfil.php', form)
	},
	setOTP: (datos) => {
		return post('set-otp.php', datos)
	},
	changePassword: (datos) => {
		return post('set-password.php', datos)
	},
	updatePassword: (datos) => {
		return axios.post('core/php/api/sesion/cambiar-pass.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/components/mi-perfil/apiUsuario.js